import type { FC, ReactNode } from 'react'
import type { Customer } from '@/types'

import { Ban, Copy, Ellipsis, Eye, Repeat, RotateCcw } from 'lucide-react'
import { Button } from '@/components/ui/button'

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger
} from '@/components/ui/dropdown-menu'

interface CustomerActionsMenuProps {
    customer: Customer
    onView: (customer: Customer) => void
    onCopyEmail: (customer: Customer) => void
    onChangePlan: (customer: Customer) => void
    onCancel: (customer: Customer) => void
    onReactivate: (customer: Customer) => void
}

export const CustomerActionsMenu: FC<CustomerActionsMenuProps> = ({
    customer,
    onView,
    onCopyEmail,
    onChangePlan,
    onCancel,
    onReactivate
}): ReactNode => {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger
                render={<Button variant='ghost' size='icon-sm' aria-label={`Aksi untuk ${customer.company}`} />}
                onClick={(event) => event.stopPropagation()}
            >
                <Ellipsis />
            </DropdownMenuTrigger>

            <DropdownMenuContent align='end' className='w-52'>
                <DropdownMenuGroup>
                    <DropdownMenuItem onClick={() => onView(customer)}>
                        <Eye />
                        Lihat detail
                    </DropdownMenuItem>
                    <DropdownMenuItem onClick={() => onCopyEmail(customer)}>
                        <Copy />
                        Salin email
                    </DropdownMenuItem>
                    {customer.status !== 'canceled' && (
                        <DropdownMenuItem onClick={() => onChangePlan(customer)}>
                            <Repeat />
                            Ubah paket
                        </DropdownMenuItem>
                    )}
                </DropdownMenuGroup>

                <DropdownMenuSeparator />

                <DropdownMenuGroup>
                    {customer.status === 'canceled'
                        ? (
                            <DropdownMenuItem onClick={() => onReactivate(customer)}>
                                <RotateCcw />
                                Aktifkan kembali
                            </DropdownMenuItem>
                        )
                        : (
                            <DropdownMenuItem variant='destructive' onClick={() => onCancel(customer)}>
                                <Ban />
                                Batalkan langganan
                            </DropdownMenuItem>
                        )}
                </DropdownMenuGroup>
            </DropdownMenuContent>
        </DropdownMenu>
    )
}
